import { Injectable } from '@angular/core';
import { IFormMasterBuilder } from '../form/form-master.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { List } from 'immutable';
import { Rating } from './models/rating-item.model';

@Injectable()
export class ReviewFormBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    COMMENT: 'comment',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(ratings: List<Rating>, commentMaxLength: number): FormGroup {
    const ratingField = ratings.toJS().reduce((acc, rating) => {
      return {
        ...acc,
        [rating.id]: [0, [Validators.min(1)]],
      };
    }, {});

    return this._formBuilder.group(
      {
        ...ratingField,
        [this.FORM_KEYS.COMMENT]: [
          '',
          [Validators.maxLength(commentMaxLength)],
        ],
      },
      { updateOn: 'blur' }
    );
  }
}
